(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 6128:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(87560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ssrAdapter_components_useIHeartTracking; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/components/useIHeartTracking/index.ts

var useIHeartTracking = function useIHeartTracking(param) {
    var action = param.action;
    (0,react.useEffect)(function() {
        var pixel = document.createElement("img");
        var params = new URLSearchParams();
        params.append("ad_log", "referer");
        if (action) {
            params.append("action", action);
        }
        params.append("pixid", "dfd0fbd9-e7bd-4f9b-83ca-25f7bee979d8");
        pixel.src = "https://arttrk.com/pixel/?".concat(params.toString());
        pixel.width = 1;
        pixel.height = 1;
        pixel.style.position = "fixed";
        pixel.alt = "";
        document.body.appendChild(pixel);
        return function() {
            document.body.removeChild(pixel);
        };
    }, [
        action
    ]);
    return null;
};
/* harmony default export */ var components_useIHeartTracking = (useIHeartTracking);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/useIHeartTracking.js

/* harmony default export */ var ssrAdapter_components_useIHeartTracking = (components_useIHeartTracking);


/***/ }),

/***/ 87560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/templates/LandingV2/index.tsx + 3 modules
var LandingV2 = __webpack_require__(42272);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Translation/index.js + 23 modules
var Translation = __webpack_require__(80055);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/Landing/index.js




var Landing = function Landing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingV2/* default */.Z, {
        heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.title"
        }),
        subHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.subtitle"
        })
    });
};
/* harmony default export */ var scenes_Landing = (Landing);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/pages/HomePage.js

/* harmony default export */ var HomePage = (scenes_Landing);

// EXTERNAL MODULE: ./src/components/templates/MarketingTemplate/index.ts + 7 modules
var MarketingTemplate = __webpack_require__(90539);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/useIHeartTracking.js + 1 modules
var useIHeartTracking = __webpack_require__(75371);
;// CONCATENATED MODULE: ./src/pages/index.tsx




var Home = function(param) {
    var featureFlags = param.featureFlags, navigation = param.navigation, user = param.user;
    (0,useIHeartTracking/* default */.Z)({
        action: "lead"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTemplate/* default */.Z, {
        featureFlags: featureFlags,
        navigation: navigation,
        user: user,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9452,944,8869,3413,9101,9779,4026,2682,1724,5646,7885,8936,7994,539,7401,253,446,9774,2888,179], function() { return __webpack_exec__(6128); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);